import React from 'react';
import BookingSummaryPanelRow from '#/components/BookingSummaryPanel/components/BookingSummaryPanelRow';
import { formatCurrency } from '#/lib/currency';
import { Money, Payment } from '@jucy/rentals-api-client';
import { SxProps, Theme } from '@mui/material';
import { format } from 'date-fns';

export interface BookingSummaryPaymentRowsProps {
    payments?: Payment[];
    sx?: SxProps<Theme>;
}

const BookingSummaryPaymentRows = ({ payments, ...props }: BookingSummaryPaymentRowsProps) =>
    payments?.map((p, i) => (
        <BookingSummaryPanelRow
            key={`payment-${i}`}
            title={format(p.date, 'dd MMM yyyy')}
            subTitle={p.type === 'DPS' ? 'Online - credit card' : p.type}
            value={formatCurrency(p.total as Required<Money>)}
            isPaymentDetails={true}
            {...props}
        />
    )) || null;

export default BookingSummaryPaymentRows;
